module.exports = __webpack_public_path__ + "static/media/corporate-services-img67.990f73d3.jpg";